




















import Vue from "vue";
import { Events, LiveUpdate } from "@timesheets/webapp-support";
import { ITypedEvent, TypedEvent } from "@gemma/events";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { IStringable } from "@gemma/typescript-types";

export default Vue.extend({
  name: "LiveUpdates",

  data(): { update?: LiveUpdate } {
    return {
      update: undefined,
    };
  },

  created() {
    WebApplicationConstants.listenerEventBuses.system.on(
      Events.RouteChangedEvent.Type,
      () => {
        this.update = undefined;
      },
      this
    );

    this.$app.liveUpdateBus.on<ITypedEvent<string, LiveUpdate<any>>, string | LiveUpdate<any>, unknown, string>(this.$app.liveUpdateBus.delimiters.wildcard, this.onLiveUpdate);
  },

  destroyed() {
    this.$app.liveUpdateBus.off(undefined, undefined, this);
    this.update = undefined;
  },

  methods: {
    async onClose(update: LiveUpdate): Promise<void> {
      this.$emit("removed", update);
      const event = new TypedEvent("removed" + this.$app.liveUpdateBus.delimiters.namespace + update.type, update.data);
      await this.$app.liveUpdateBus.emit(event);
      this.update = undefined;
    },

    async onRefresh(update: LiveUpdate) {
      this.$emit("refreshed", update);
      const event = new TypedEvent("refreshed" + this.$app.liveUpdateBus.delimiters.namespace + update.type, update.data);
      await this.$app.liveUpdateBus.emit(event);
      this.update = undefined;
    },

    onLiveUpdate<TEvent extends ITypedEvent<IStringable, TEventData>, TEventData>(event: TEvent, message: string): string | LiveUpdate<TEventData> {
      const type = event.type.toString(this.$app.liveUpdateBus.delimiters);
      if (type.startsWith("refreshed") || type.startsWith("removed")) {
        return "LiveUpdates ignore own messages";
      }

      const liveUpdate: LiveUpdate<TEventData> = {
        id: event.id,
        data: event.data,
        isHTML: false,
        message,
        type,
      };

      this.update = liveUpdate;

      return liveUpdate;
    },
  },
});
